import { Modal, Tooltip } from "flowbite-react";
import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { HiDotsHorizontal, HiOutlineTrash } from "react-icons/hi";
import { MdOutlineLocationOn } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getProducersByFilter, getProducerTotalCount, removeProducer } from '../../redux/producerReducer';
// import { insertProducerInCart, removeProducerInCart, setCartItemActive } from '../../redux/locationReducer';
import date from 'date-and-time';
import { useTranslation } from "react-i18next";
import swal from 'sweetalert2';
import { S3_BUCKET, S3_BUCKET_RESIZE } from '../../config/constants';
import { openSnackBar } from '../../redux/snackBarReducer';
// import DuplicateProducer from "./DuplicateProducer";
import EditProducer from './EditProducer';

function ProducerTableItem(props) {
    const { t } = useTranslation();
    const { authState, globalState } = useSelector((state) => state);
    const { userInfo } = authState;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [permission, setPermission] = useState(false);
    const [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        if (props.condition.role === 0) { // admin 
            setPermission(true);
        }else {
            setPermission(false);
        }
        // } else if (props.condition.role === 1) { // company owner
        //     if (props.data.company._id === props.condition.company && props.data.is_global === props.condition.isGlobal) {
        //         setPermission(true);
        //     } else {
        //         setPermission(false);
        //     }
        // } else if (props.condition.role === 2) {// company stuff
        //     if (props.data.company._id === props.condition.company && props.data.is_global === props.condition.isGlobal && props.data.created_by._id === props.condition.user_id) {
        //         setPermission(true);
        //     } else {
        //         setPermission(false);
        //     }
        // }
    }, [props.condition, props.data])

    const clickDelete = async (value) => {

        if (permission) {
            swal.fire({
                title: t("swal_are_you_sure"),
                text: t("swal_del_producer"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t("swal_delete")
            })
                .then(async result => {
                    if (result.isConfirmed) {
                        let res = await dispatch(removeProducer(value));
                        if (res !== false) {
                            dispatch(openSnackBar({ message: t("msg_success_del_producer"), status: 'success' }));
                            await dispatch(getProducersByFilter(props.condition));
                            await dispatch(getProducerTotalCount(props.condition));
                        }
                    }
                });
        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_not_permission") }));
        }
    }

    const { name, logo, producer_image1, producer_image2, country, region, is_created_by_user, created_at, modified_at, description, _id } = props.data;

    return (
        <>
            <tr className={props.last ? "bg-white" : "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"}>
                <th onClick={() => setModalShow(true)} scope="row" className="flex items-center py-4 px-6 text-gray-900 whitespace-nowrap dark:text-white">
                    <div className="flex justify-center w-20 h-20">
                        {
                            logo.changed_name ? 
                                logo.changed_name.indexOf(".svg") != -1 ? 
                                    <img className="w-auto rounded-full" src={`${S3_BUCKET}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                                :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                            :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                        }
                        {/* <img className="w-auto rounded-full" src={`${S3_BUCKET}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" /> */}
                    </div>
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{is_created_by_user?.firstname + " " + is_created_by_user?.lastname}</div>
                        <div className="text-base font-semibold">{name ? name : "N/A"}</div>
                    </div>
                </th>
                <td onClick={() => setModalShow(true)} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("country")}</div>
                        <div className="text-base font-semibold">{country ? country.name[`${globalState.language}`] : "N/A"}</div>
                    </div>
                </td>
                <td onClick={() => setModalShow(true)} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("region")}</div>
                        <div className="text-base font-semibold">{region ? region.name[`${globalState.language}`] : "N/A"}</div>
                    </div>
                </td>
                <td onClick={() => setModalShow(true)} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("created")}</div>
                        <div className="text-base font-semibold">{created_at ? date.format(new Date(created_at), 'YYYY/MM/DD HH:mm:ss') : "N/A"}</div>
                    </div>
                </td>
                <td onClick={() => setModalShow(true)} className="py-4 px-6">
                    <div className="pl-3">
                        <div className="font-normal text-gray-500">{t("last_modified")}</div>
                        <div className="text-base font-semibold">{modified_at ? date.format(new Date(modified_at), 'YYYY/MM/DD HH:mm:ss') : "N/A"}</div>
                    </div>
                </td>
                <td className="py-4 px-6">
                    <Tooltip
                        style="light"
                        content={
                            <div >
                                {/* <DuplicateProducer product_id={_id} permission={permission} /> */}
                                <EditProducer producer={props.data} condition={props.condition} />
                                <div onClick={() => clickDelete(_id)} className="flex text-red-500 p-1 cursor-pointer hover:bg-gray-100">
                                    {/* <HiOutlineTrash className="h-6 w-6 mr-2 text-red-500" /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M9.40381 17.1923V10.2692"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 17.1923V10.2692"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M0.75 5.07692H23.25"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z"/></svg>
                                    {t("delete")}
                                </div>
                            </div>
                        }
                        placement="left"
                        arrow={false}
                        trigger="hover"
                    >
                        <HiDotsHorizontal className="w-6 h-6" />
                    </Tooltip>
                </td>
            </tr>

            <Modal
                show={modalShow}
                size="2xl"
                popup={true}
                onClose={() => setModalShow(false)}
            >
                <Modal.Header className="py-5 px-6">
                    {t("producer_info")}
                </Modal.Header>
                <hr />
                <Modal.Body 
                    className="overflow-y-auto !py-0"
                    style={{ maxHeight: "80vh" }}
                >
                    <div className="py-6 text-sitetx-200">
                        <div className="grid grid-cols-5 gap-4">
                            <div className="col-span-1 m-auto">
                                {
                                    logo.changed_name ? 
                                        logo.changed_name.indexOf(".svg") != -1 ? 
                                            <img className="w-auto rounded-full" src={`${S3_BUCKET}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                                        :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                                    :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" />
                                }
                                {/* <img className="w-auto h-auto rounded-full" src={`${S3_BUCKET}${logo.changed_name ? logo.changed_name : "company-empty.png"}`} alt="empty" /> */}
                            </div>
                            <div className="col-span-4">
                                {/* <div className="text-base font-semibold">{country.name[`${globalState.language}`] + " " + region.name[`${globalState.language}`]}</div> */}
                                <div className="text-3xl font-bold">{name}</div>

                                <div className="text-2xl font-bold pt-8 pb-2 flex"><MdOutlineLocationOn className="w-6 h-6 my-auto" /> Location</div>
                                <div className="text-base">{country.name[`${globalState.language}`] + ">" + region.name[`${globalState.language}`]}</div>
                            </div>
                        </div>
                        <hr />
                        <div>
                            <div className="pt-4 pl-8">
                                {description ? description : "Not description"}
                            </div>
                            <div>
                                {
                                    // producer_image1.changed_name && 
                                    //     producer_image1.changed_name.indexOf(".svg") != -1 ? 
                                    //             <img className="w-auto rounded-full" src={`${S3_BUCKET}${producer_image1.changed_name}`} alt="empty" />
                                    //         :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${producer_image1.changed_name}`} alt="empty" />
                                    <img className="w-auto h-auto rounded-full" src={`${S3_BUCKET}${producer_image1.changed_name}`} alt="empty" />
                                }
                                {
                                    // producer_image2.changed_name &&
                                    //     producer_image2.changed_name.indexOf(".svg") != -1 ? 
                                    //         <img className="w-auto rounded-full" src={`${S3_BUCKET}${producer_image2.changed_name}`} alt="empty" />
                                    //     :   <img className="w-auto rounded-full" src={`${S3_BUCKET_RESIZE}${producer_image2.changed_name}`} alt="empty" />
                                    <img className="w-auto h-auto rounded-full" src={`${S3_BUCKET}${producer_image2.changed_name}`} alt="empty" />
                                }

                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className=" flex items-center justify-end" style={{width:'100%'}}>
                        <div className="col-span-5 flex pl-12 gap-8">
                            {
                                userInfo?.role === 0 &&
                                <div onClick={() => clickDelete(_id)} className="flex text-red-500 p-1 cursor-pointer hover:bg-gray-100">
                                    {/* <HiOutlineTrash className="h-6 w-6 mr-2 text-red-500" /> */}
                                    <svg className="h-5 w-5 mr-2 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5">
                                        <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z"/>
                                        <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M9.40381 17.1923V10.2692"/>
                                        <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 17.1923V10.2692"/>
                                        <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M0.75 5.07692H23.25"/>
                                        <path stroke="red" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z"/></svg>
                                    {t("delete")}
                                </div>
                            }
                            <EditProducer producer={props.data} condition={props.condition} />
                        </div>

                        {/* </div><div className="col-span-3 flex gap-8 justify-end">
                        <label onClick={() => getPrevCompany()} className="flex flex-col justify-center items-center float-right w-16 h-16 bg-white rounded-lg border-2 border-sitetx-100 cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-sitebg-200 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                            <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                <SlArrowLeft className="text-black h-6 w-6" />
                            </div>
                        </label>
                        <label onClick={() => getNextCompany()} className="flex flex-col justify-center items-center float-right w-16 h-16 bg-white rounded-lg border-2 border-sitetx-100 cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-sitebg-200 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                            <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                <SlArrowRight className="text-black h-6 w-6" />
                            </div>
                        </label> */}
                    </div>
                </Modal.Footer>
            </Modal>
        </ >

    );
}

export default ProducerTableItem;